import * as React from "react";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridItemChangeEvent,
  GridPageChangeEvent,
  GridPagerSettings,
  GridRowProps,
} from "@progress/kendo-react-grid";
import ResourceTable from "./resources";
import PositionTable from "./positions";
import AppliedResourcesTable from './aplliedCandidates'
import RegistrationApproval from './registrationApproval'
import { Resources } from "./interfaces";
import "./tablestyle.scss";
import { checkAvailability } from "../../utils/EllowUtils";
import { useEffect, useState } from "react";
import ButtonDefault from "../button";
import { DropDown } from "./myDropDown";
import { getAPI } from "../../api/api";
import AllCompanies from "./allCompanies";
import { REACT_APP_RECRUITER } from "../../utils/common";
import ActivePositions from "./activePositions";
import SubmittedCandidates from "./submittedCandidates";
import ProviderTable from "./providerTable";
import UsersTable from "./users";
import AwardsCertifications from "./awardsCertifications"
import CheckHistoryTable from "./checkHistory";
import CompanyTimesheet from "./companyTimesheet";
import CandidateTimesheet from "./candidateTimesheet";
import TimeSheetSettingsCandidate from "./timesheetSettingsCandidateList";
import CandidateTimesheetTable from "./candidateTimesheetHistory"
import HolidayList from "./holidayList";
import CandidateLeaveDetails from "./candidateLeaveDetails"
import PublicDatabaseTable from "./publicDatabaseTable"
import UploadHistoryTable from "./uploadHistortTable"
import CandidateTimesheetDownloadList from "./candidateTimesheetDownloadList";
import ReportsTable1 from './reportsTables/report1'
import ReportsTable2 from './reportsTables/report2'
import ReportsTable5 from "./reportsTables/report5";
import ReportsTable3 from "./reportsTables/report3";
import ReportsTable4 from "./reportsTables/report4";
import CRresourcesTable from "./CRTables/CRresources";
import CRPositionTable from "./CRTables/CRPositions";
import CRAppliedResourcesTable from "./CRTables/CRappliedCandidates";
import ReferredTable from "./referredCandidates";

interface AppState {
  items: any;
  total: number;
  skip: number;
  pageSize: number;
  pageable: GridPagerSettings;
}

const Table = (props: any) => {

  const [allocatedTo, setAllocatedTo] = useState<any>();

  const createState = (skip: number, take: number, items: any) => {

    let pagerSettings: GridPagerSettings = {
      buttonCount: 20,
      info: true,
      type: "numeric",
      pageSizes: props.type === 'candiatetimesheet' ? [100, 150, 200] : [25, 50, 100],
      previousNext: true,
    };
    return {
      items: items,
      total: props.total && props.total,
      skip: skip,
      pageSize: take,
      pageable: pagerSettings,
    };
  };


  const [state, setState] = useState<AppState>(createState(0, props.type === 'candiatetimesheet' ? 100 : 25, props.data));
  const [data, setData] = useState<Array<Resources>>(state.items);
  const [changes, setChanges] = useState<boolean>(false);
  const [resource, setResource] = useState();

  useEffect(() => {
    if (state) {
      setState(createState(state.skip, state.pageSize, props.data));
      setData(state.items)
    }
  }, [props.total, props.data])


  useEffect(() => {

    getAPI(REACT_APP_RECRUITER + "/list").then((response) => {
      if (response && response.status === 1) {
        setAllocatedTo(response.data)
      }
    });
  }, [])


  const pageChange = (event: GridPageChangeEvent) => {
    
    setState(createState(event.page.skip, event.page.take, props.data));
    props.pageSize(event.page.take, event.page.skip)

  };

  const itemChange = (event: GridItemChangeEvent) => {

    let field = event.field || "";
    event.dataItem[field] = event.value;
    let newData = data.map((item: any) => {
      if (item.name === event.dataItem.name) {
        item[field] = event.value;
      }
      return item;
    });
    setData(newData);
    setChanges(true);
  };

  const rowClick = (e: any) => {
    
    if (e.dataItem.candidateId) {
      let inEdit = true
      let newEdit = false
      let newData = props.data.map((item: any) =>
        item.candidateId === e.dataItem.candidateId ? { ...item, inEdit, allocatedTo } : { ...item, newEdit });
      setState(createState(state.skip, state.pageSize, newData))
    }
    if (e.dataItem.loginId) {
      let inEdit = true
      let newEdit = false
      let newData = props.data.map((item: any) =>
        item.loginId === e.dataItem.loginId  ? { ...item, inEdit, allocatedTo } : { ...item, newEdit });
      setState(createState(state.skip, state.pageSize, newData))
    }
    if (e.dataItem.jobId) {
      let inEdit = true
      let newEdit = false
      let newData = props.data.map((item: any) =>
        item.jobId === e.dataItem.jobId ? { ...item, inEdit, allocatedTo } : { ...item, newEdit });
      setState(createState(state.skip, state.pageSize, newData))
    }
    if (e.dataItem.timesheetId) {
      let inEdit = true
      let newEdit = false
      let newData = props.data.map((item: any) =>
        item.timesheetId === e.dataItem.timesheetId ? { ...item, inEdit, allocatedTo } : { ...item, newEdit });
      setState(createState(state.skip, state.pageSize, newData))
    }
  }

  const getTables = (type: string) => {
    if (type === 'positions') {
      props.getTablesValues()
    }
    if (type === 'appliedCandidates') {
      props.getAppliedCandidates()
    }
    if (type === 'resources') {
      props.getTablesValues()

    }
    if (type === 'candiatetimesheet') {
      props.getTablesValues()

    }
  }

  return (
    <>
    <div className="tableStyle">
      {props && props.type === 'resources' && <ResourceTable setSort={props.setSort} applySort={props.applySort} draftKey={props.draftKey} getResourceTables={() => getTables('resources')} pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} rowClick={rowClick} hideStatus={props.hideStatus} hideSubmittedTo={props.hideSubmittedTo}/>}
      {props && props.type === 'positions' && <PositionTable setSort={props.setSort} draftKey={props.draftKey} applySort={props.applySort} getTables={() => getTables('positions')} pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} rowClick={rowClick} />}
      {props && props.type === 'appliedCandidates' && <AppliedResourcesTable setSort={props.setSort} applySort={props.applySort} jobMetadata={props.jobMetadata} getTables={() => getTables('appliedCandidates')} pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} rowClick={rowClick} jobId={props.jobId} customerId={props.customerId} getPositionDetails={props.getPositionDetails} allocatedToId={props.allocatedToId} positionData={props.positionData}/>}
      {props && props.type === 'registrationApproval' && <RegistrationApproval setSort={props.setSort} applySort={props.applySort} getAllCompaniesData={props.getAllCompaniesData} approveOrRejectCustomer={props.approveOrRejectCustomer} getTables={() => getTables('positions')} pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} rowClick={rowClick}  draftCompany={props.draftCompany}/>}
      {props && props.type === 'allCompanies' && <AllCompanies setSort={props.setSort} applySort={props.applySort} getTables={() => getTables('positions')} pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} rowClick={rowClick} />}
      {props && props.type === 'activePositions' && <ActivePositions setSort={props.setSort} applySort={props.applySort} data={props.data && props.data} />}
      {props && props.type === 'submittedCandidates' && <SubmittedCandidates setSort={props.setSort} applySort={props.applySort} data={props.data && props.data} />}
      {props && props.type === 'providertable' && <ProviderTable applySort={props.applySort} setSort={props.setSort} data={data} state={state} approveOrRejectCustomer={props.approveOrRejectCustomer} />}
      {props && props.type === 'usersTable' && <UsersTable data={props.data && props.data} defaultValues={props.defaultValues} addNewUser={props.addNewUser} editUserStatus={props.editUserStatus} getUser={props.getUser} customerId={props.customerId} />}
      {props && props.type === 'awardsCertifications' && <AwardsCertifications data={props.data && props.data} updateAwardCertifications={props.updateAwardCertifications} defaultValues={props.defaultValues} customerId={props.customerId} />}
      {props && props.type === 'checkHistory' && <CheckHistoryTable data={props.data} onClose={props.onClose} sendReminder={props.sendReminder} />}
      {props && props.type === 'companyTimesheets' && <CompanyTimesheet state={state} data={data} pageChange={pageChange} itemChange={itemChange} total={props.total} setSort={props.setSort} applySort={props.applySort} />}
      {props && props.type === 'candiatetimesheet' && <CandidateTimesheet state={state} data={data} pageChange={pageChange} itemChange={itemChange} total={props.total} setSort={props.setSort} applySort={props.applySort} showHistory={props.showHistory} sendReminder={props.sendReminder} rowClick={rowClick} getTables={() => getTables('candiatetimesheet')} />}
      {props && props.type === 'settingscandiatetimesheet' && <TimeSheetSettingsCandidate state={state} data={data} pageChange={pageChange} itemChange={itemChange} total={props.total} setSort={props.setSort} applySort={props.applySort} sendReminder={props.sendReminder} showHistory={props.showHistory} />}
      {props && props.type === 'candidateTimesheetHistory' && <CandidateTimesheetTable data={props.data} onClose={props.onClose} sendReminder={props.sendReminder} />}
      {props && props.type === 'holidayList' && <HolidayList data={props.data} />}
      {props && props.type === 'candiatetimesheetdownload' && <CandidateTimesheetDownloadList data={props.data} />}
      {props && props.type === 'candidateLeaveDetails' && <CandidateLeaveDetails data={props.data} pageChange={pageChange} state={state} />}
      {props && props.type === 'publicDatabase' && <PublicDatabaseTable setSort={props.setSort} applySort={props.applySort} draftKey={props.draftKey} getResourceTables={() => getTables('resources')} pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} rowClick={rowClick} hideStatus={props.hideStatus} />}
      {props && props.type === 'uploadHistory' && <UploadHistoryTable setSort={props.setSort} applySort={props.applySort} draftKey={props.draftKey} getResourceTables={() => getTables('resources')} pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} rowClick={rowClick} hideStatus={props.hideStatus} />} 
      {props && props.type === 'ReportsTable1' && <ReportsTable1 data={props.data} counts={props.counts} state={state} pageChange={pageChange} itemChange={itemChange} filtereResults={props.filtereResults}/>}
      {props && props.type === 'ReportsTable2' && <ReportsTable2 data={props.data} counts={props.counts} state={state} pageChange={pageChange} itemChange={itemChange} total={props.total} filtereResults={props.filtereResults}/>}
      {props && props.type === 'ReportsTable5' && <ReportsTable5  pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} />}
      {props && props.type === 'ReportsTable3' && <ReportsTable3  pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} />}
      {props && props.type === 'ReportsTable4' && <ReportsTable4  pageChange={pageChange} data={props.data} total={props.total} itemChange={itemChange} />}
      {props && props.type === 'CRresources' && <CRresourcesTable pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} rowClick={rowClick} setSort={props.setSort} applySort={props.applySort}/>}
      {props && props.type === 'CRPositions' && <CRPositionTable pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} rowClick={rowClick} setSort={props.setSort} applySort={props.applySort}/>}
      {props && props.type === 'CRAppliedResources' && <CRAppliedResourcesTable setSort={props.setSort} applySort={props.applySort} jobMetadata={props.jobMetadata} getTables={() => getTables('appliedCandidates')} pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} rowClick={rowClick} jobId={props.jobId} customerId={props.customerId} getPositionDetails={props.getPositionDetails} allocatedToId={props.allocatedToId}  submitPostCandidateToJob={props.submitPostCandidateToJob}/>}
        {props && props.type === 'referral' && <ReferredTable setSort={props.setSort} applySort={props.applySort} draftKey={props.draftKey} getResourceTables={() => getTables('resources')} pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} rowClick={rowClick} hideStatus={props.hideStatus} hideSubmittedTo={props.hideSubmittedTo} paymentSubmit={props.paymentSubmit} modal={props.modal}/>}
        {/* {props && props.type === 'providerResources' && <CRAppliedResourcesTable setSort={props.setSort} applySort={props.applySort} jobMetadata={props.jobMetadata} getTables={() => getTables('appliedCandidates')} pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} rowClick={rowClick} jobId={props.jobId} customerId={props.customerId} getPositionDetails={props.getPositionDetails} allocatedToId={props.allocatedToId}  submitPostCandidateToJob={props.submitPostCandidateToJob}/>} */}
    </div>

    </>
      );
};

export default Table;
